import { Gap, Modal, Span } from '@salecycle/ui-component-library';
import { ExitIntentAreas } from 'sections/onsite-campaigns/types';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { ExitIntentAreaSelector } from './ExitIntentSelector';

export type ExitIntentConfigurationModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  value: ExitIntentAreas[];
  onChange: (newValue: ExitIntentAreas[]) => void;
};

const toggleSelectedIntent = (intent: ExitIntentAreas, currentIntents: ExitIntentAreas[]) => {
  return currentIntents.includes(intent) ? currentIntents.filter(p => p !== intent) : [...currentIntents, intent];
};

export function ExitIntentAreaSelectorModal({ isOpen, setIsOpen, value, onChange }: ExitIntentConfigurationModalProps) {
  const { t } = useTranslation(['designs', 'campaigns']);

  const onSave = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const handleClose = () => setIsOpen(false);

  const onExitIntentSet = useCallback(
    (intent: ExitIntentAreas) => {
      onChange(toggleSelectedIntent(intent, value));
    },
    [onChange, value],
  );

  const selectAllExitIntent = useCallback(() => onChange(Object.values(ExitIntentAreas)), [onChange]);

  const unselectAllExitIntent = useCallback(() => onChange([]), [onChange]);

  return (
    <Modal
      heading="Select exit intent hotspots"
      variation="clean"
      isOpen={isOpen}
      onCloseButtonClicked={handleClose}
      onOkButtonClicked={onSave}
      okButtonLabel="Confirm"
      okButtonDisabled={!value.length}
      minWidth={848}
    >
      <Span>
        <p>{t('campaigns:onsite.exitIntentAreaSelectorModal.heading')}</p>
        <p>{t('campaigns:onsite.exitIntentAreaSelectorModal.message')}</p>
        <Gap bottom={34} />
        <ExitIntentAreaSelector
          value={value}
          onChange={onExitIntentSet}
          selectAllExitIntent={selectAllExitIntent}
          unselectAllExitIntent={unselectAllExitIntent}
        />
      </Span>
    </Modal>
  );
}
